import { render, staticRenderFns } from "./ArticleVideo.vue?vue&type=template&id=425b4ee3&"
import script from "./ArticleVideo.vue?vue&type=script&lang=coffee&"
export * from "./ArticleVideo.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports